import React, { PropsWithChildren } from 'react';
import { MaintenancePage } from './MaintenancePage';

export function MaintenanceGuard({ children }: PropsWithChildren<{}>) {
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
}
